export default __webpack_public_path__ + "static/media/ic_st_barts.8ee944cd.svg";